import { Component, Injector, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { Utilityservice } from '../../utility/utilityservice.service';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
import { MycredentialsService } from '../../main-layout/mycredentials/mycredentials.service';
import { BaseClass } from '../../utility/baseClass';

@Component({
  selector: 'app-mycredentialmodal',
  templateUrl: './mycredentialmodal.component.html',
  styleUrls: ['./mycredentialmodal.component.css']
})
export class MycredentialmodalComponent extends BaseClass implements OnInit {

  credentialForm: FormGroup;
  onlyView: any;
  tempData: any;
  tempUpdateData: any;

  saveTitle = "Add";
  isEdit: boolean = false;
  rid: any = null;

  CSRFToken = "";
  showPass = false;

  CredentialDetails: any = {};

  constructor(
    private credentialService: MycredentialsService,
    private fb: FormBuilder,
    public router: Router,
    public override injector: Injector,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private utilityserv: Utilityservice,
  ) {
    super(injector);
    this.gettoken();

    const dataFromParent = this.config.data;
    if (dataFromParent?.title == 'Modify Credential') {
      this.saveTitle = 'Modify';
      this.isEdit = true;
      this.CredentialDetails = dataFromParent.datas;
      console.log(this.CredentialDetails = dataFromParent.datas);

    }
  }


  public validation_message = {
    url: [
      { type: 'required', message: 'URL Name is required' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end' },
    ],
    userid: [
      { type: 'required', message: 'User ID is required' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end' },
    ],
    password: [
      { type: 'required', message: 'Password is required' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end' },
    ],
    description: [
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end' },
    ]
  };

  ngOnInit() {
    this.initializeForm();
    this.getData();
  }

  initializeForm() {
    this.credentialForm = this.fb.group({
      url: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(200),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT)
      ])],
      userid: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(50),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT)
      ])],
      password: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(30),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT)
      ])],
      description: ['', Validators.compose([
        Validators.maxLength(450),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT)
      ])],
      csrftoken: ['']
    });
  }

  getData() {
    this.patchData(this.CredentialDetails)

  }
  patchData(data) {
    this.rid = data[0].rid,
      this.credentialForm.patchValue({
        url: data[0].url,
        userid: data[0].userid,
        password: data[0].password,
        description: data[0].description
      });
  }


  closeDialog() {
    Swal.fire({
      title: "Are you sure, you want to close?",
      showDenyButton: true,
      confirmButtonText: "No",
      denyButtonText: `Yes`
    }).then((result) => {
      if (result.isDenied) {
        this.ref.close();
      }
    });
  }


  saveCredential() {
    if (this.credentialForm.invalid) {
      this.validateAllFormFields(this.credentialForm);
      return;
    }
    const payload = {
      url: this.credentialForm.get('url').value,
      userid: this.credentialForm.get('userid').value,
      password: this.credentialForm.get('password').value,
      description: this.credentialForm.get('description').value,
      csrftoken: this.CSRFToken
    };
    if (this.saveTitle === 'Modify') {
      this.modifyCredential(payload);
    } else {
      this.addCredential(payload);
    }
  }
  addCredential(payload: any) {
    Swal.fire({
      title: "Do you want to save the changes?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
      denyButtonText: "Don't Save"
    }).then(result => {
      if (result.isConfirmed) {
        this.credentialService.createCredential(payload).subscribe((resp: any) => {
          if (resp.response === 'exists') {
            Swal.fire("Credential already exists!", "", "error");
          } else {
            Swal.fire("Credential added successfully!", "", "success").then(() => {
              this.ref.close();
            });
          }
        }, error => {
                    if(error.error.response == 'html') {
                          Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                                        })
                                      }       
                  });
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved!", "", "info");
        this.ref.close();
      }
    });
  }


  modifyCredential(payload: any) {
    payload['rid'] = this.rid;
    Swal.fire({
      title: "Do you want to save the changes?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
      denyButtonText: "Don't Save"
    }).then(result => {
      if (result.isConfirmed) {
        this.credentialService.updateCredential(payload).subscribe((resp: any) => {
          if (resp.response === 'exists') {
            Swal.fire("Credential already exists!", "", "error");
          } else {
            Swal.fire("Credential modified successfully!", "", "success").then(() => {
              this.ref.close();
            });
          }
        },error => {
          if(error.error.response == 'html') {
            Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
            })
        }       
                  });
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved!", "", "info");
        this.ref.close();
      }
    });
  }

  gettoken() {
    this.utilityserv.getCSRFtoken().subscribe((res: any) => {
      this.CSRFToken = res.csrf;
    });
  }
}
